import {Amplify, Cache } from "aws-amplify";
import { getAPIData, updateAPIData } from "./APIData";
// import awsExports from './aws-exports';
import { ConsoleLogger } from "@aws-amplify/core";

const _STRIPE_TEST = false;

export async function getUser() {
  try {
    let user = await Amplify.Auth.currentAuthenticatedUser({
      bypassCache: true,
    });
    if (!user.attributes["custom:display_notice"]) {
      // Default display notice: In order to adapt to the hidden checkbox on the page, set the value of display_notice to the opposite
      user.attributes["custom:display_notice"] = "False";
      await Amplify.Auth.updateUserAttributes(user, {
        "custom:display_notice": "False",
      });
    }
    if (!user.attributes["custom:user_type"]) {
      user.attributes["custom:user_type"] = "Dentist";
      await Amplify.Auth.updateUserAttributes(user, {
        "custom:user_type": "Dentist",
      });
    }
    if (!user.attributes["custom:tooth_num_system"]) {
      user.attributes["custom:tooth_num_system"] = "UNS";
      await Amplify.Auth.updateUserAttributes(user, {
        "custom:tooth_num_system": "UNS",
      });
    }
    if (!user.attributes["custom:email_on_status"]) {
      user.attributes["custom:email_on_status"] = "True";
      await Amplify.Auth.updateUserAttributes(user, {
        "custom:email_on_status": "True",
      });
    }
    if (!user.attributes["custom:email_on_clinical"]) {
      user.attributes["custom:email_on_clinical"] = "True";
      await Amplify.Auth.updateUserAttributes(user, {
        "custom:email_on_clinical": "True",
      });
    }
    if (!user.attributes["custom:email_on_notes"]) {
      user.attributes["custom:email_on_notes"] = "True";
      await Amplify.Auth.updateUserAttributes(user, {
        "custom:email_on_notes": "True",
      });
    }
    user = await Amplify.Auth.currentAuthenticatedUser();
    Amplify.Cache.setItem("user", user.attributes);
    return user;
  } catch (err) {
    console.error(err);
  }
}

export async function updateUser(update) {
  try {
    // const creds = await Amplify.Auth.currentCredentials();
    // const params = { queryStringParameters: { userid: creds.identityId } };
    // Check for account type to get the right table/endpoint . . .
    // const data = await getAPIData('dentist', params);
    const user = await Amplify.Auth.currentAuthenticatedUser();
    return await Amplify.Auth.updateUserAttributes(user, update);
  } catch (err) {
    console.error(err);
  }
}

export async function getUserId() {
  try {
    const creds = await Amplify.Auth.currentCredentials();
    return creds.identityId;
  } catch (err) {
    console.error(err);
  }
}


export async function createUser(message) {
  try {
    const msg = {
      email: message.email,
      token: message.token,
      // test: awsExports.aws_content_delivery_bucket.includes('prod')?  false : true
      test: false,
    };
    const data = await updateAPIData("customers", { body: msg });
    return msg;
  } catch (err) {
    console.error(err);
  }
}

export async function getBillingAccount() {
  const session = await Amplify.Auth.currentSession();
  const access_token = session.accessToken.jwtToken;
  const creds = await Amplify.Auth.currentCredentials();

  const params = {
    queryStringParameters: {
      userid: creds.identityId,
      access_token,
      callback_url: window.location.href,
      billing_service: "account",
    },
  };
  if (_STRIPE_TEST) params.queryStringParameters.test = true;
  let data = await getAPIData("billing", params);
  Amplify.Cache.setItem("billing", data);

  return data;
}

export async function getOrderHistory() {
  const session = await Amplify.Auth.currentSession();
  const access_token = session.accessToken.jwtToken;
  const creds = await Amplify.Auth.currentCredentials();
  const params = {
    queryStringParameters: {
      userid: creds.identityId,
      access_token,
      callback_url: " ",
      billing_service: "order_history",
    },
  };

  if (_STRIPE_TEST) params.queryStringParameters.test = true;
  let data = await getAPIData("billing", params);
  return data;
}

export async function getDefaultSource() {
  let billing = Amplify.Cache.getItem("billing");
  if (!billing) billing = await getBillingAccount();
  if (
    billing &&
    billing.sources &&
    Array.isArray(billing.sources.data) &&
    billing.sources.data.length
  ) {
    return billing.sources.data[0];
  }
}

export async function getSubscriptions() {
  let billing = Amplify.Cache.getItem("billing");
  if (!billing) billing = await getBillingAccount();
  if (
    billing &&
    billing.subscriptions &&
    Array.isArray(billing.subscriptions.data) &&
    billing.subscriptions.data.length
  ) {
    return billing.subscriptions.data[0];
  }
}

export async function getFreeTrialActive() {
  let billing = Amplify.Cache.getItem("billing");
  if (!billing) billing = await getBillingAccount();
  return billing && billing.free_trial;
}

export async function getBillingPortal() {
  try {
    const session = await Amplify.Auth.currentSession();
    const access_token = session.accessToken.jwtToken;
    const creds = await Amplify.Auth.currentCredentials();
    const params = {
      queryStringParameters: {
        userid: creds.identityId,
        access_token,
        callback_url: window.location.origin,
        billing_service: "portal",
      },
    };
    if (_STRIPE_TEST) params.queryStringParameters.test = true;

    let data = await getAPIData("billing", params);
    return data;
  } catch (err) {
    console.error(err);
  }
}

export const archform_plans = _STRIPE_TEST
  ? {
      Pro: {
        month: { price: 499, stripeid: "price_1J0tQmIffkoglhLDen3rNdnt" },
        year: { price: 424, stripeid: "price_1KHFBrIffkoglhLDtPIeEUrF" },
      },
      Premium: {
        month: { price: 299, stripeid: "price_1J0tQWIffkoglhLDACJSvhwQ" },
        year: { price: 254, stripeid: "price_1KHFCHIffkoglhLD7Hb7zENE" },
      },
      Basic: {
        month: { price: 199, stripeid: "price_1J0tPPIffkoglhLDaRMcVdLn" },
        year: { price: 169, stripeid: "price_1KHFBIIffkoglhLDrq6ucvYe" },
      },
      Patient: {
        month: { price: 0, stripeid: "price_1JHwD3IffkoglhLDNoIkxlhy" },
        year: { price: 0, stripeid: "price_1JHwD3IffkoglhLDNoIkxlhy" },
      },
    }
  : {
      Pro: {
        month: { price: 1200, stripeid: "price_1Mj7HPIffkoglhLDNN0ARC4a" },
        year: { price: 424, stripeid: "plan_GJMj3lds5NdCfb" },
      },
      Premium: {
        month: { price: 299, stripeid: "plan_GJMgEgSyhIK8TS" },
        year: { price: 254, stripeid: "plan_GJMhbKVfeKJOSl" },
      },
      Basic: {
        month: { price: 199, stripeid: "plan_GJMd7ExvUFdeFM" },
        year: { price: 169, stripeid: "plan_GJMfkvUQNegNi0" },
      },
      Patient: {
        month: { price: 0, stripeid: "price_1KStQvIffkoglhLDUo3CrG3r" },
        year: { price: 0, stripeid: "price_1KStQvIffkoglhLDUo3CrG3r" },
      },
    };

export const archform_products = {
  "In Office": "price_1J0tRnIffkoglhLD2kSUl5c7",
  Orthodontist: "price_1JZkmVIffkoglhLD3Q0hA8fZ",
  Technician: "price_1JZkmoIffkoglhLDhw6jaJka",
};

//$.00 USD / month price_1J0tQmIffkoglhLDen3rNdnt
//$424.00 USD / month price_1J84xsIffkoglhLDMnZOqYvW

//Premium
//$299.00 USD / month price_1J0tQWIffkoglhLDACJSvhwQ
//$254.00 USD / month price_1J84zJIffkoglhLDjfaZPYFO

// Basic
// $199.00 USD / month price_1J0tPPIffkoglhLDaRMcVdLn
// $169.00 USD / month price_1J84zjIffkoglhLDq8f1Za7z

// Patient
// $50.00 USD price_1J0tRnIffkoglhLD2kSUl5c7

export async function getCheckout(price) {
  const session = await Amplify.Auth.currentSession();
  const access_token = session.accessToken.jwtToken;
  const creds = await Amplify.Auth.currentCredentials();

  const params = {
    queryStringParameters: {
      userid: creds.identityId,
      access_token,
      price,
      callback_url: window.location.origin,
      billing_service: "checkout",
    },
  };
  if (_STRIPE_TEST) params.queryStringParameters.test = true;

  if (price) params.price = price;
  let data = await getAPIData("billing", params);
  return data;
}

export async function getProductCheckout(callback_url, price) {
  const session = await Amplify.Auth.currentSession();
  const access_token = session.accessToken.jwtToken;
  const creds = await Amplify.Auth.currentCredentials();

  const params = {
    queryStringParameters: {
      userid: creds.identityId,
      access_token,
      callback_url,
      billing_service: "product_checkout",
    },
  };
  if (price) params.queryStringParameters.price = price;
  if (_STRIPE_TEST) params.queryStringParameters.test = true;
  let data = await getAPIData("billing", params);
  return data;
}

// WEBPACK FOOTER //
// ./src/User.js
